import React, { useState, useContext } from "react";
import "../../sass/components/pre_login/_login_form.scss";
import Loader from '../common/Loader'
import ErrMapper from '../common/ErrMapper'
import ApiService  from "../../services/api.service";
import { useDispatch } from 'react-redux';
import IdleTimer from "../../services/utils/Timer";
import {ThemeContext} from "../../styles/ThemeContext";

const LoginForm = ({modalVisible,setModalVisible, setPage,userName, setUsername, setValidationDetails,setUserCredentials, page})=>{
    const { theme } = useContext(ThemeContext);
    const [step, setStep] = useState("login");
    const [loader, showLoader] = useState(false);
    const [error, setError] = useState('');
    const [password, setPassword] = useState();
    const [inputClass, setinputClass] = useState('disabled')
    const [togglePassword, setPasswordVisible] = useState(false);
    const dispatch = useDispatch();
    const handleChangeInput = (e) => {
        e.length > 4 ? setinputClass('active') : setinputClass("disabled")
    }

    const toggleView = () => {
        setPasswordVisible(prevCheck => !prevCheck)
    }
    const handleLogin = (e) => {
        e.preventDefault();
        showLoader(true)
        if (step === 'login') {
            ApiService.post("/auth/validate_agrodealer", { username: userName }).subscribe((res) => {
                setError('');
                showLoader(false)
                if (res.status == 200) {
                    showLoader(false)
                    setValidationDetails(res.data)
                    if (res.data.firstLogin === false) {
                        setStep('password');
                    } else if (res.data.firstLogin) {
                        const payload = {
                            username: userName,
                            password: password
                        }
                        ApiService.post("/auth/send_otp", payload).subscribe((res) => {
                            if (res.status === 200) {
                                setModalVisible(true)
                            }

                        })
                        setModalVisible(true)
                    }
                    else {
                        setPage("password");
                    }

                }
                else if (res.response !== undefined && res.response.status === 400) {
                    showLoader(false)
                    setError(res.response.data && res.response.data.error ? res.response.data.error : "An error occured")
                } else if (res.response !== undefined && res.response.status === 500) {
                    setError(res.response.data.message ? res.response.data.message : "Internal Server Error")
                } else if (res.code === "ERR_NETWORK") {
                    setError("No internet connection");
                } else {
                    setError("An error occuredd");
                }
            })
        } else {
            const payload = {
                username: userName,
                password: password
            }
            const subscription = ApiService.post("/auth/login", payload).subscribe((res) => {
                showLoader(false)
                //   setModalVisible(true)
                if (res.status === 200) {
                    // DISPATCH  CREDENTIALS TO STORE
                    // setModalVisible(true)
                    const time = new Date();
                    let logtime = { "logtime": time.getTime() }
                    const userdata = Object.assign(res.data, logtime)
                    setUserCredentials(userdata)

                    // TRIGGER SEND OTP
                    const payload = {
                        username: userName,
                    }
                    const subscription = ApiService.post("/auth/send_otp", payload).subscribe((res) => {
                        if (res.status === 200) {
                            setModalVisible(true)
                        }

                    })


                }
                else if (res.response !== undefined && res.response.status === 400) {
                    setError("Invalid username or password")
                } else {
                    setError("An error occured")
                }

            })
        }
    }
    
    
        
                    
            
            
       
    return (
        <div className="login-form">
            <Loader loader={loader} />
            <div className="login-image-background" />
            <h1 className="login-title-web">Co-op Bank - KCEP Portal</h1>
            <h1 className="login-title-mob">Co-op Bank - KCEP Agro Dealer</h1>
            <form>
                { step === "password"  && <div className="back-holder" onClick={()=>{setStep("login")}}>
                        <svg className="icon-arrow-back" viewBox="0 0 24 24" height="20" width="24">
                            <path fill="white" d="M20.016 11.016v1.969h-12.188l5.578 5.625-1.406 1.406-8.016-8.016 8.016-8.016 1.406 1.406-5.578 5.625h12.188z"></path>
                        </svg>
                        <span className="back-text">Back</span>
                    </div>}
                <fieldset>
                    <h6 className="instructions">Enter {step === "login" ? "username" : "password"} to proceed</h6>

                    <h6 className="label">{step === "login" ? "Username" : "Password"}</h6>
                    {step === "login" && <input type="text" onChange={(e) => { setUsername(e.target.value); handleChangeInput(e.target.value) }} placeholder="Enter username" />}
                    {step === "password" && <input type={togglePassword ? "text" : "password"} onChange={(e) => { setPassword(e.target.value); setError('') }} placeholder="Enter password" />}
                    {step === "password" && <svg id="icon-remove_red_eye" className="eye toggle-eye" onClick={toggleView} viewBox="0 0 24 24">



                        {togglePassword ? <path d="M12 9q1.219 0 2.109 0.891t0.891 2.109-0.891 2.109-2.109 0.891-2.109-0.891-0.891-2.109 0.891-2.109 2.109-0.891zM12 17.016q2.063 0 3.539-1.477t1.477-3.539-1.477-3.539-3.539-1.477-3.539 1.477-1.477 3.539 1.477 3.539 3.539 1.477zM12 4.5q3.703 0 6.703 2.063t4.313 5.438q-1.313 3.375-4.313 5.438t-6.703 2.063-6.703-2.063-4.313-5.438q1.313-3.375 4.313-5.438t6.703-2.063z"></path> : <path d="M11.859 9h0.141q1.219 0 2.109 0.891t0.891 2.109v0.188zM7.547 9.797q-0.563 1.125-0.563 2.203 0 2.063 1.477 3.539t3.539 1.477q1.078 0 2.203-0.563l-1.547-1.547q-0.375 0.094-0.656 0.094-1.219 0-2.109-0.891t-0.891-2.109q0-0.281 0.094-0.656zM2.016 4.266l1.266-1.266 17.719 17.719-1.266 1.266q-0.234-0.234-1.477-1.453t-1.898-1.875q-2.016 0.844-4.359 0.844-3.703 0-6.703-2.063t-4.313-5.438q0.516-1.219 1.617-2.695t2.133-2.273q-0.563-0.563-1.57-1.594t-1.148-1.172zM12 6.984q-0.938 0-1.828 0.375l-2.156-2.156q1.828-0.703 3.984-0.703 3.703 0 6.68 2.063t4.289 5.438q-1.125 2.766-3.422 4.734l-2.906-2.906q0.375-0.891 0.375-1.828 0-2.063-1.477-3.539t-3.539-1.477z"></path>}


                    </svg>}
                </fieldset>
                <ErrMapper err={error} />
                <button className={`next ${inputClass}`} onClick={(e) => { handleLogin(e); }} type='submit'> {step === "login" ? "Next" : "Sign In"}</button>
                <button className="reset-password" onClick={(e) => { e.preventDefault(); setPage("self") }}>I have trouble logging in</button>
            </form>

        </div>
    )
}

export default LoginForm
